import { addStyles } from './index.es.js';

var panel = "mc63185e72_panel";
var panelHead = "mc63185e72_dls-typography-desktop-title-reg-large mc63185e72_panelHead";
var panelName = "mc63185e72_dls-typography-desktop-title-reg-large mc63185e72_panelName";
var panelBody = "mc63185e72_dls-typography-desktop-body-reg-medium mc63185e72_panelBody";
var panelFoot = "mc63185e72_panelFoot";
var styles = ".mc63185e72_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mc63185e72_dls-typography-desktop-title-reg-large{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:28px;letter-spacing:0;line-height:40px}.mc63185e72_panel{background:transparent;color:#3e3939;display:flex;flex-direction:column;flex:1 0 auto}.mc63185e72_panelHead{border-bottom:1px solid #e0e3e4;padding-bottom:12px}.mc63185e72_panelBody{margin-top:24px}";

addStyles([{
  attributeName: 'theme',
  attributeValue: 'landing-summary',
  className: 'ignore',
  styles: styles,
  parts: {
    panel: panel,
    panelHead: panelHead,
    panelName: panelName,
    panelBody: panelBody,
    panelFoot: panelFoot
  }
}]);
